export const environment = {
  logErrors: false,
  name: 'dev',
  production: false,
  sentryDsn:
    'https://4885bd60a999a7d2236782ece2034c1c@o1216314.ingest.us.sentry.io/4507137984167936',
  serverRoot: 'https://api-dev.app.simx-infra.com',
  internalInstitutions: ['4abbfadb-5611-4cdc-8dd4-5de2a0fff56d'],
};
